import {Injectable} from '@angular/core';
import {ApiService} from "../../api/api.service";
import {BehaviorSubject, Observable} from "rxjs";
import {IAction} from "../../../../pages/management/authorization-management/models/action.interface";
import {IPagination} from "../../api/interface/pagination.interface";
import {IndexedDBService} from "../../indexdb/indexeddb.service";

@Injectable({
  providedIn: 'root'
})
export class ActionService {

  private readonly totalActionSubject = new BehaviorSubject<number>(0);
  totalAction$ = this.totalActionSubject.asObservable();

  updateTotalAction(totalAction: number) {
    this.totalActionSubject.next(totalAction);
  }

  constructor(private readonly apiService: ApiService, private readonly indexedDBService: IndexedDBService) {
  }

  async actionCheck(key: string, action: string): Promise<boolean> {
    const data = await this.indexedDBService.getData('authority', key).catch(err=>null);
    const result = data?.find((item: any) => item[action] === true);


    if (result) {
      return result;
    }
    return false;
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`action/action-filter-list`, {event: event, filter: filter})
  }

  getList() {
    return this.apiService.get<any>('action')
  }

  create(action: IAction): Observable<IAction> {
    return this.apiService.post<IAction>('action/create', action)
  }

  update(action: IAction): Observable<IAction> {
    return this.apiService.patch<IAction>('action/update', action);
  }

  delete(actionId: string,): Observable<IAction> {
    return this.apiService.delete<IAction>(`action/delete/${actionId}`);
  }

  assignAuthority(assignData: any[]) {
    return this.apiService.post<any>('action/add-authority', assignData)
  }

  unassignAuthority(assignData: any[]) {
    return this.apiService.post<any>('action/remove-authority', assignData)
  }

}
